import { mapActions, mapState } from 'vuex';

import { updatePaymentMixin } from './updatePayment.mixin';
import { sendRequestOfPaymentAdapter } from '../adapters/payment.adapter';

export const handlePaymentMixin = {
  name: 'handlePaymentMixin',
  mixins: [updatePaymentMixin],
  computed: {
    ...mapState({
      currentAdmission: ({ currentAdmission }) => currentAdmission.data,
    }),
  },
  methods: {
    ...mapActions(['createAdmissionPaymentCommand']),

    async handlePayment_mixin(payload) {
      const paymentCurrentAdmission = this.currentAdmission.payments && this.currentAdmission.payments[0];
      const hasCurrentPayment = paymentCurrentAdmission && !!paymentCurrentAdmission.uuid;
      const paymentPayload = sendRequestOfPaymentAdapter(payload);

      const paymentAlreadyExists = paymentPayload.transactionId || hasCurrentPayment;

      if (!paymentAlreadyExists) {
        return this.createAdmissionPaymentCommand(paymentPayload);
      }

      return this.updateAdmissionPaymentCommand_mixin(paymentPayload);
    },
  },
};
